const Unicon = ({ icon: Icon, ...rest }) => {
  return <Icon {...rest} />;
};

export default Unicon;
